export const Theme = {
  text: {
    title: {
      fontFamily: 'Poppins',
      fontWeight: '500'
    },
    description: {
      fontFamily: 'Poppins',
      fontWeight: '400'
    },
  },
  colors: {
    primary: '#472CF0',
    black: '#212529',
    white: '#fff',
    colorNeutralLight: '#8798AD'
  }
}

